import React from 'react'
import {Link, useRouteMatch} from 'react-router-dom'
import {MdInfoOutline} from 'react-icons/md'
import {Breadcrumbs, Grid, Typography} from '@material-ui/core/'
import {useTranslation} from 'react-i18next'
import breadcrumbs from './breadcrumbs'
import useStyles from './BarcodeHeader.styles'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import BarcodeToolTip from '../BarcodeToolTip'
import BarcodeSettings from '../BarcodeSettings'
import BarcodePopButton from '../BarcodePopButton'

function BarcodeHeader(props) {
  const routeMatch = useRouteMatch()
  const {t} = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid container className={classes.container}>
        <Grid item xs={6}>
          <Breadcrumbs aria-label="Breadcrumb" separator={<NavigateNextIcon fontSize="small" />}>
            {(breadcrumbs[routeMatch.path] || []).map((links, index, arr) => (
              <span key={index}>
                {arr.length - 1 === index ? (
                  <Typography key={index} className={classes.breadcrumbLink}>
                    {t(links['title'])}
                  </Typography>
                ) : (
                  <Link key={index} className={classes.breadcrumbLink} to={links['url']}>
                    {t(links['title'])}
                  </Link>
                )}
              </span>
            ))}
          </Breadcrumbs>
        </Grid>
        <Grid item xs={6}>
          <BarcodePopButton>
            <BarcodeSettings />
          </BarcodePopButton>
          <BarcodeToolTip
            size={16}
            tooltipInfo={{
              image: <MdInfoOutline size={22} />,
              colorTransparent: true,
              title:
                "Asset Panda's built in barcode generator software allows you to create barcode designs to print onto labels, allowing you to scan and search within your account for items with a click of a button.",
            }}
          />
        </Grid>
      </Grid>

      {/* <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={showFlashMessage}
        autoHideDuration={3000}
        onClose={closeFlashMessage}
      >
        <FlashMessage
          onClose={closeFlashMessage}
          variant={flashVariant ? flashVariant : 'success'}
          message={flashMessage}
        />
      </Snackbar> */}
    </div>
  )
}

export default BarcodeHeader
